(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mx-header-v4"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.getElementById('mxh4');
    if (!root) return;
    const drawer = root.querySelector('.mxh4-drawer');
    const opener = root.querySelector('[data-mxh4-open]');
    const setOpen = (open) => {
      root.classList.toggle('is-open', open);
      drawer.setAttribute('aria-hidden', String(!open));
      opener.setAttribute('aria-expanded', String(open));
      document.documentElement.style.overflow = open ? 'hidden' : '';
      if (open) drawer.querySelector('button')?.focus();
      else opener.focus();
    };
    opener.addEventListener('click', () => setOpen(true));
    root.querySelectorAll('[data-mxh4-close]').forEach((el) => el.addEventListener('click', () => setOpen(false)));
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && root.classList.contains('is-open')) setOpen(false);
    });

    const sBtn = root.querySelector('[data-mxh4-search]');
    const sForm = root.querySelector('.mxh4-search');
    sBtn.addEventListener('click', () => {
      const show = sForm.hidden;
      sForm.hidden = !show;
      sBtn.setAttribute('aria-expanded', String(show));
      if (show) sForm.querySelector('input[type=search]').focus();
    });

    const ann = root.querySelector('.mxh4-ann');
    if (ann) {
      const msgs = ann.querySelectorAll('.mxh4-ann__msg');
      const ms = parseInt(ann.dataset.interval, 10) || 4000;
      if (msgs.length > 1 && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
        let i = 0;
        setInterval(() => {
          msgs[i].classList.remove('is-on');
          i = (i + 1) % msgs.length;
          msgs[i].classList.add('is-on');
        }, ms);
      }
    }

    document.addEventListener('shopify:cart:lines-update', (event) => {
      event.promise?.then(({ cart, userErrors }) => {
        if (userErrors?.length || !Number.isInteger(cart?.totalQuantity)) return;
        root.querySelectorAll('[data-mxh4-cnt]').forEach((el) => {
          el.textContent = cart.totalQuantity;
          el.hidden = cart.totalQuantity === 0;
        });
        root.querySelectorAll('[data-mx-cart-link]').forEach((a) => a.setAttribute('aria-label', `Koszyk, liczba produktów: ${cart.totalQuantity}`));
      }).catch(() => {});
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mx-header"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('shopify:cart:lines-update', event => {
  event.promise?.then(({ cart, userErrors }) => {
    if (userErrors?.length || !Number.isInteger(cart?.totalQuantity)) return;
    document.querySelectorAll('[data-mx-cart-link]').forEach(link => {
      link.setAttribute('aria-label', `Koszyk, liczba produktów: ${cart.totalQuantity}`);
      const label = link.querySelector('[data-mx-cart-label]');
      if (label) label.textContent = `Koszyk (${cart.totalQuantity})`;
      link.classList.remove('mx-cart-bump');
      void link.offsetWidth;
      link.classList.add('mx-cart-bump');
    });
  }).catch(() => {});
});
const closeMega = group => {
  group.dataset.open = 'false';
  group.querySelector('.mx-mega-toggle')?.setAttribute('aria-expanded', 'false');
};
document.querySelectorAll('.mx-mega-group').forEach(group => {
  const toggle = group.querySelector('.mx-mega-toggle');
  toggle?.addEventListener('click', () => {
    const next = group.dataset.open !== 'true';
    document.querySelectorAll('.mx-mega-group').forEach(closeMega);
    group.dataset.open = String(next);
    toggle.setAttribute('aria-expanded', String(next));
  });
  group.querySelector('.mx-mega-close')?.addEventListener('click', () => {
    closeMega(group);
    toggle?.focus();
  });
  group.addEventListener('mouseenter', () => {
    if (matchMedia('(min-width: 1101px)').matches) toggle?.setAttribute('aria-expanded', 'true');
  });
  group.addEventListener('mouseleave', () => {
    if (group.dataset.open !== 'true') toggle?.setAttribute('aria-expanded', 'false');
  });
});
document.addEventListener('keydown', event => {
  if (event.key === 'Escape') {
    document.querySelectorAll('.mx-mega-group').forEach(closeMega);
  }
});
document.addEventListener('click', event => {
  if (!event.target.closest('.mx-mega-group')) document.querySelectorAll('.mx-mega-group').forEach(closeMega);
});

  } catch(e) { console.error(e); }
})();
})();
